// test1393
(1393 && 0);
